/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Empty chart
 */

// Dependencies
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';

/**
 * Empty chart Component.
 * @return { Node } React Empty chart Component
 */
const EmptyChart = () => {
  const { t: translate } = useTranslation();
  return (
    <div className="w-full flex justify-center items-center mt-5">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={translate('commons.noData')}
        style={{ color: '#858fab', fontSize: 15 }}
      />
    </div>
  );
};
export default EmptyChart;
